// Produzione: URL assoluto Cloud Run (VITE_API_BASE in CI).
// Dev locale: /api → proxy Vite verso localhost:3000.
export const APP_VERSION = '0.19.0-web';
export const API_BASE = import.meta.env.VITE_API_BASE ?? '/api';
export const POLL_INTERVAL_MS = 30_000;
export const POLL_BACKOFF_MAX_MS = 5 * 60 * 1000;
export const POLL_JITTER_MAX_MS = 5_000;
export const MEDIA_PREFETCH_CONCURRENCY = 2;
// Ping di liveness ogni 5 min. La telemetria è event-based: l'API non
// storicizza i ping (aggiorna solo lastSeenAt), registra solo le transizioni
// di stato. La soglia offline server-side è 6 min (tollera un tick perso).
export const HEARTBEAT_INTERVAL_MS = 5 * 60_000;
export const CACHE_QUOTA_BYTES = 500 * 1024 * 1024; // 500 MB
export const LOG_BUFFER_SIZE = 50;
export const SLOT_TRANSITION_MS = 300;
export const ADMIN_QUERY_PARAM = 'admin';
export const TRIPLE_TAP_TIMEOUT_MS = 500;
export const TRIPLE_TAP_CORNER_PX = 100;
